import React, {FunctionComponent} from 'react';
import './RoundTipButton.less';

interface RoundTipButtonProps {
	text: string;
	isPressed: boolean;
	onClick: () => void,
}

export const RoundTipButton: FunctionComponent<RoundTipButtonProps> = ({text, isPressed, onClick}) => {
	return (
		<button
			className={`round-tip-button ${isPressed ? 'round-tip-button--active' : ''}`}
			onClick={onClick}
		>
			{text}
		</button>
	);
};
